module.exports = __webpack_public_path__ + "img/x2000_green-leds.0f1dfde8.png";